/* eslint-disable max-len */
import React from 'react';
import {Link} from 'react-router-dom';
import {Input} from 'semantic-ui-react';
import '../styles.scss';
import {jsonToParams} from '../../utils/commonUtils';

export const Filter = ({column}) => {
  return <div>{column.canFilter && column.render('Filter')}</div>;
};

const sumColumnsCreateOrder = [
  'transitNotAvailable',
  'transitDeposit',
  'transitTransit',
  'transitTotal',
  'transitFree',
  'transitReservations',
  'depositNotAvailable',
  'depositFree',
  'depositReservations',
  'depositTotal',
  'depositSolNac',
];

const sum = (arr, id) =>
  arr.reduce((accumulator, object) => {
    return accumulator + parseInt(object.values[`${id}`] || 0, 10);
  }, 0);

export const DefaultColumnFilter = ({'column': {filterValue, setFilter}}) => {
  return (
    <div className="full-width">
      <Input
        className="input-custom-small"
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || null);
        }}
      />
    </div>
  );
};

export const FloatingSummaryColumnFilter = ({
  'column': {filterValue, setFilter, id, preFilteredRows},
  requestData,
}) => {
  return (
    <>
      {!sumColumnsCreateOrder.includes(id) ? (
        <span></span>
      ) : (
        <>
          {id === 'totalUnits' ? (
            <span>{sum(preFilteredRows, id)}</span>
          ) : (
            <Link
              to={`/vehiculos/inventario-flotante?group=${id}&${jsonToParams(requestData)}`}
            >
              {sum(preFilteredRows, id) || 0}
            </Link>
          )}
        </>
      )}
    </>
  );
};
